import React from 'react';
import useStore from '../store/useStore';
import WallContainer from './WallContainer';
import '../css/custom.css';
import logo from '../logo/HDD_PrimaryLogo_Blue.png';
import myLogo from '../images/HDSBCPartnershipLogos_HDDistributing.png';
import panelDataSec from '../config/panelsLED.json';


function PrintArea({maxLEDWidth, maxLEDHeight, pixelPitch, ledModel, orderNumber}) {

    const unit = useStore((state) => state.unit);

    const wallWidth = useStore((state) => state.wallWidth);
    const wallHeight = useStore((state) => state.wallHeight);

    const selectedWall = "Indoor";
    const product = "Crystal";

    const panelDetails = panelDataSec[selectedWall][product][ledModel][pixelPitch] || [];

    const wallAspectRatio = (wallWidth / wallHeight).toFixed(2);

    // Calculate dynamic width and height based on aspect ratio
    const wallContainerWidth = wallAspectRatio >= 1 ? '275' : `${wallAspectRatio * 275}`;  //origon 480
    const wallContainerHeight = wallAspectRatio < 1 ? '275' : `${275 / wallAspectRatio}`;

    //calculate final resolutions
    const finalresWidth = (panelDetails.resolutionWidth * (maxLEDWidth / panelDetails.panelWidth)).toFixed(0);
    const finalresHeight = (panelDetails.resolutionHeight * (maxLEDHeight / panelDetails.panelHeight)).toFixed(0);

    const aspectRatio = ((panelDetails.panelWidthmm * maxLEDWidth/panelDetails.panelWidth) / (panelDetails.panelHeightmm * maxLEDHeight/panelDetails.panelHeight));
    const DiagonalDis = (maxLEDWidth * maxLEDWidth) + (maxLEDHeight * maxLEDHeight);
    const overallDistance =((maxLEDWidth + (panelDetails.frameSize * 2 * 0.00328)) * (maxLEDWidth + (panelDetails.frameSize * 2 * 0.00328))) + ((maxLEDHeight + (panelDetails.frameSize * 2 * 0.00328)) * (maxLEDHeight + (panelDetails.frameSize * 2 * 0.00328)));

    const projectName = useStore((state) => state.projectName);
    const budget = useStore((state) => state.budget);
    const bid = useStore((state) => state.bid);
    const projectApplication = useStore((state) => state.projectApplication);
    const estimateInstallDate = useStore((state) => state.estimateInstallDate);
    const mount = useStore((state) => state.mount);
    const onsiteCommissioningRequired = useStore((state) => state.onsiteCommissioningRequired);
    const warrantyRequirement = useStore((state) => state.warrantyRequirement);
    const inputResolution = useStore((state) => state.inputResolution);
    const quantityOfInputs = useStore((state) => state.quantityOfInputs);
    const trimRequired = useStore((state) => state.trimRequired);

    const date = new Date().toISOString();
    const centralTime = new Date(date).toLocaleString('en-US', {
    timeZone: 'America/Chicago',
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    });
  
    // Remove the comma by replacing it with a space (if needed)
    const formattedCentralTime = centralTime.replace(',', '');

    return (

        <div>
                    <div className="d-flex flex-row mb-3">
          <div>
            <img src={logo} alt="HD White Logo" height="75"></img>
          </div>
          <div className="print-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>SBC dvLED Configurator - {projectName} - SBC{orderNumber} </div><div>{formattedCentralTime}</div>
          </div>
        </div>
        <div className="row align-items-center">
        <div className="col-6 mt-5">
              <div className="row custom-border-color-print p-4">
                <h5>Project Details</h5><hr/>
                <div className="col-6 ">
                    <div id="text-primary">Budget</div>
                      <div>{budget || '-'}</div>
                    <div className="mt-2" id="text-primary">Project Application</div>
                      <div>{projectApplication || '-'}</div>
                    <div className="mt-2" id="text-primary">Mount</div>
                      <div>{mount || '-'}</div>
                    <div className="mt-2" id="text-primary">Warranty Requirement</div>        
                      <div>{warrantyRequirement || '-'}</div>
                    <div className="mt-2" id="text-primary">Quantity of Inputs</div>        
                      <div>{quantityOfInputs || '-'}</div>
                </div>
                <div className="col-6">
                    <div className="" id="text-primary">Bid</div>
                      <div>{bid || '-'}</div>
                    <div className="mt-2" id="text-primary">Est. Installation Date</div>
                      <div>{estimateInstallDate || '-'}</div>
                    <div className="mt-2" id="text-primary">Onsite Comminsioning</div>
                      <div>{onsiteCommissioningRequired || '-'}</div>
                    <div className="mt-2" id="text-primary">Input Resolution</div>
                      <div>{inputResolution || '-'}</div>
                    <div className="mt-2" id="text-primary">Trim Required</div>
                      <div>{trimRequired || '-'}</div>
                </div>
              </div>
            </div>
            <div className="col-6">
                <div className="mt-3">
                  <WallContainer
                    maxLEDWidth={maxLEDWidth}
                    maxLEDHeight={maxLEDHeight}
                    wallContainerWidth={wallContainerWidth}
                    wallContainerHeight={wallContainerHeight}
                    panelDetails={panelDetails}
                  />
                </div>
            </div>
        </div>
        <div className="row mt-3">
          <div className="col-6">
            <div className="row custom-border-color-print mt-3 p-4 h-100">
                <div className="row">
                  <h5>Wall Max Size</h5><hr/>
                  <div className="col-6">
                      <div id="text-primary">Wall Width</div>
                      <div className="mt-1">{ unit === 'ft' ? (1 * wallWidth).toFixed(2) : (0.3048 * wallWidth).toFixed(2)} ({unit})</div>
                  </div>
                  <div className="col-6">
                      <div id="text-primary">Wall Height</div>
                      <div className="mt-1">{unit ==='ft' ? (1 * wallHeight).toFixed(2) : (0.3048 * wallHeight).toFixed(2)} ({unit})</div>
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Display Configuration</h5><hr/>
                    <div className="col-6">
                        <div id="text-primary">Columns</div>
                        <div className="mt-1">{(unit === 'ft' ? maxLEDWidth : maxLEDWidth * 0.3048).toFixed(2)} ({unit})</div>
                    </div>
                    <div className="col-6">
                        <div id="text-primary">Rows</div>
                      <div className="mt-1">{(unit === 'ft' ? maxLEDHeight : maxLEDHeight * 0.3048).toFixed(2)} ({unit})</div>
                    </div>
                </div>
                <div className="row mt-3">
                  <h5>LED Display Specs</h5><hr/>
                    <div className="col-6">
                      <div id="text-primary">Wall Setup</div>
                      <div>{selectedWall}</div>
                      <div className="mt-2" id="text-primary">Choose DVLED Product</div>
                      <div>{product}</div>
                    </div>
                    <div className="col-6">
                      <div id="text-primary">Modual Type</div>
                      <div>{ledModel}</div>
                      <div className="mt-2" id="text-primary" >Pixel Pitch</div>
                      <div>{pixelPitch}</div>
                    </div><br></br>
                </div>
            </div>
          </div>
          <div className="col-6">
              <div className="row custom-border-color-print mt-3 p-4 h-100">
                <h5>Screen Configuration</h5><hr/>
                  <div className="col-6">
                      <div id="text-primary">Single Panel Size</div>
                        <div>{panelDetails.panelWidth ? `${panelDetails.panelWidth} x` : '-'} {panelDetails.panelHeight ? `${panelDetails.panelHeight} (Ft)` : ''}</div>
                        <div>{panelDetails.panelWidthinch ? `${panelDetails.panelWidthinch} x` : ''} {panelDetails.panelHeightinch ? `${panelDetails.panelHeightinch} (Inch)` : ''}</div>
                        <div>{panelDetails.panelWidthmm ? `${panelDetails.panelWidthmm} x` : ''} {panelDetails.panelHeightmm ? `${panelDetails.panelHeightmm} (mm)` : ''}</div>           
                      <div className="mt-2" id="text-primary">Resolution</div>
                        <div>{panelDetails.resolutionWidth ? `${finalresWidth} x ${finalresHeight}` : '-' }</div>
                        <div className="mt-2" id="text-primary">Display Diagonal Distance</div>
                      <div>
                              {aspectRatio ? `${(Math.sqrt(DiagonalDis) * 12).toFixed(2)} (Inch)` : '-'}<br/>
                              {aspectRatio ? `${(Math.sqrt(DiagonalDis) * 12 * 25.4).toFixed(2)} (mm)` : '-'}
                      </div>
                      <div className="mt-2" id="text-primary"><span className="star-mark">*</span>Max Power Consumption <br></br> {panelDetails.perCabinetMax ? `${panelDetails.perCabinetMax} W` : ''} (Per Panel)</div>        
                      <div>
                          {
                              panelDetails.perCabinetMax
                              ? `${(panelDetails.perCabinetMax * (maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)).toFixed(0)} W`
                              : '-'
                          }
                      </div>
                    </div>
                    <div className="col-6">
                      <div id="text-primary">Panel Array</div>
                        <div>{aspectRatio ? `${(maxLEDWidth/panelDetails.panelWidth).toFixed(0)} x ${(maxLEDHeight/ panelDetails.panelHeight).toFixed(0)}` : '-'}</div>
                      <div className="mt-2" id="text-primary">Total Panels</div>
                        <div>{aspectRatio ? `${(maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)}` : '-'}</div>
                      <div className="mt-2" id="text-primary">Aspect Ratio</div>
                        <div>{panelDetails.panelWidthmm ? `${aspectRatio.toFixed(2)} : 1` : '-'}</div>
                        <div className="mt-2" id="text-primary">Overall Diagonal Distance <br></br> (Frame Border {panelDetails.frameSize}mm)</div>
                      <div>
                              {aspectRatio ? `${(Math.sqrt(overallDistance) * 12).toFixed(2)} (Inch)` : '-'}<br/>
                              {aspectRatio ? `${(Math.sqrt(overallDistance) * 12 * 25.4).toFixed(2)} (mm)` : '-'}
                      </div>
                      <div className="mt-2" id="text-primary"><span className="required-marker">*</span>Avg Power Consumption <br></br> {panelDetails.perCabinetMin ? `${panelDetails.perCabinetMin} W` : ''} (Per Panel)</div>
                      <div>
                          {
                              panelDetails.perCabinetMin
                              ? `${(panelDetails.perCabinetMin * (maxLEDWidth / panelDetails.panelWidth).toFixed(0) * (maxLEDHeight / panelDetails.panelHeight).toFixed(0)).toFixed(0)} W`
                              : '-'
                          }
                      </div>
                    </div>
                    <div className="mt-3"><span className="star-mark">*</span>Power consumption may vary based on brightness settings and is for reference only.</div>
                  </div>
          </div>        
        </div>
              
        <div className="d-flex flex-row mt-3">
            <div className="align-self-center"><img src={myLogo} alt="partner-logo" className="bottom_logo_print "></img></div>
            <div className="footer-style-print"><b>HD DISTRIBUTING | MINNEAPOLIS, MN | HD2PRO.COM | 877-307-6689</b></div>
        </div>  
        </div>

    );
}

export default PrintArea;
